/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteSecurityFile } from '../../models/delete-security-file';

export interface DeleteSecurityFile$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
      body?: DeleteSecurityFile
}

export function deleteSecurityFile(http: HttpClient, rootUrl: string, params: DeleteSecurityFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteSecurityFile.PATH, 'delete');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteSecurityFile.PATH = '/custom/station/{uid}/SecurityFile';
